import { AuthTokens } from "@/definitions/types/api/auth"

const TOKEN_KEY = "auth_data"

export const setStoredToken = (token: string): void => {
  localStorage.setItem(TOKEN_KEY, token)
}

export const getStoredToken = (): AuthTokens | null => {
  if (typeof window !== "undefined") {
    const token = localStorage.getItem(TOKEN_KEY)
    return token ? JSON.parse(token) : null
  }
  return null
}

export const clearStoredToken = (): void => {
  localStorage.removeItem(TOKEN_KEY)
}
